import { Layout } from "../../../ui/layout";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { NotificationAdminForms } from "./forms";

export function NotificationAdminPanel() {
    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Strumenti', 'Gestione Notifiche']}
            noPaddingLat
            headerLabel="Gestione Notifiche"
        >
            <NotificationAdminForms />
        </Layout>
    )
}